import React, { ElementType, useState } from 'react';
import { Link } from 'react-router-dom';
import { t } from 'i18next';
import { capitalizeFirstLetter } from 'utils/helpers';
import ConditionalRender from 'base/ConditionalRender/ConditionalRender';
import { ReadMoreModal } from './ReadMoreModal';

interface SeeMoreTextProps {
  as?: ElementType;
  className?: string;
  maxChars: number;
  link?: string;
  children: string | JSX.Element;
  showPopValue?: JSX.Element;
  inputType: 'text' | 'other';
  headerText?: string;
}

const SeeMoreText = ({
  children,
  as: Tag = 'p',
  className,
  maxChars,
  link,
  showPopValue,
  inputType = 'text',
  headerText
}: SeeMoreTextProps) => {
  const [showReadMoreModal, setShowReadMoreModal] = useState(false);

  const renderReadMoreModal = () => {
    if (showReadMoreModal) {
      return (
        <ReadMoreModal
          closeModal={() => setShowReadMoreModal(false)}
          data={showPopValue || children}
          headerText={headerText}
        />
      );
    }
  };
  return (
    <Tag className={className}>
      <ConditionalRender
        condition={inputType === 'text' && typeof children === 'string'}
        fallBack={
          <Link
            to={link || ''}
            onClick={e => {
              e.preventDefault();
              setShowReadMoreModal(true);
            }}
            className="fw-semibold"
          >
            {capitalizeFirstLetter(t('general.text_2'))}
          </Link>
        }
      >
        {typeof children === 'string' ? children.slice(0, maxChars) : children}
        {typeof children === 'string' && children.length > maxChars && (
          <>
            <>...</>
            <Link
              to={link || ''}
              onClick={e => {
                e.preventDefault();
                setShowReadMoreModal(true);
              }}
              className="fw-semibold"
            >
              {capitalizeFirstLetter(t('general.text_2'))}
            </Link>
          </>
        )}
      </ConditionalRender>
      {renderReadMoreModal()}
    </Tag>
  );
};

export default SeeMoreText;
